import React from 'react';
import { LucideProps, RefreshCwIcon } from 'lucide-react';
import { cn } from '../utils';

export const LoadingIcon = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ className, ...props }, ref) => {
    return (
      <RefreshCwIcon
        ref={ref}
        className={cn('size-4 min-w-4 animate-spin', className)}
        {...props}
      />
    );
  }
);
